var tmp_menutouch_v2_speed = 300;

function fadeInUl(nextUl){
    nextUl.animate({
        right: "0"
    }, {
        duration: tmp_menutouch_v2_speed,
        complete: function(){
            ulSize(nextUl);
        }
    });
}
function fadeOutUl(thisUl){
    if(thisUl.parent().parent().hasClass('tmp_menutouch_v2_level_1')) {
        thisUl.parent().parent().height('auto');
    } else {
        thisUl.parent().parent().height('100%');
    }
    thisUl.parent().parent().css('overflow-y', 'auto');
    thisUl.animate({
        right: "-300px"
    }, {
        duration: tmp_menutouch_v2_speed,
        complete: function(){
            thisUl.css('display', 'none');
        }
    });
}

function ulSize(nextUl){
    var parent = nextUl.parent().parent();
    var nextUlSize = nextUl.height();
    var thisUlSize = parent.height();
    if(nextUlSize < thisUlSize) {
        if(parent.is('ul')) {
            parent.height(100);
        }
        parent.css('overflow-y', 'hidden');
    } else {
        parent.height('100%');
        parent.css('overflow-y', 'auto');
    }
}

$(document).ready(function(){
    $('.tmp_menutouch_v2 .back').each(function(){
        var levelTitle = $(this).parent().parent().find('a').html();
        $(this).find('span').html(levelTitle);
    });

    $('.tmp_menutouch_v2 .back').click(function(){
        var thisUl = $(this).parent();
        fadeOutUl(thisUl);
        return false;
    });

    $('.tmp_menutouch_v2 li a').click(function(){
        var nextUl = $(this).parent().children('ul');
        if(nextUl.length != 0) {
            nextUl.css('display', 'block');
            fadeInUl(nextUl);
        } else {
            if($(this).attr('target') == '_blank') {
                var fenster = window.open($(this).attr('href'), '_blank');
                fenster.focus();
            } else {
                window.location.href = $(this).attr('href');
            }
        }
        return false;
    });

    $('.tmp_menutouch_v2_trigger').click(function(){
        fadeInUl($('.tmp_menutouch_v2'));
        $('.tmp_menutouch_v2_close').animate({
            right: "0"
        }, {
            duration: tmp_menutouch_v2_speed
        });
        var width1 = $('body').width();
        $('body').css('overflow-y', 'hidden');
        var width2 = $('body').width();
        $('body').css('padding-right', width2-width1);

        $('#main').addClass('menuetouch-blurred');
        $('.tmp_topwrap_v1').addClass('menuetouch-blurred');
    });
    $('.tmp_menutouch_v2_close').click(function(){
        $('#main').removeClass('menuetouch-blurred');
        $('.tmp_topwrap_v1').removeClass('menuetouch-blurred');

        $('.tmp_menutouch_v2_close').animate({
            right: "-350px"
        }, {
            duration: tmp_menutouch_v2_speed
        });
        $('.tmp_menutouch_v2, .tmp_menutouch_v2_level_2, .tmp_menutouch_v2_level_3').animate({
            right: "-350px"
        }, {
            duration: tmp_menutouch_v2_speed
        });
        $('.tmp_menutouch_v2_level_2').animate({
            right: "-350px"
        }, {
            duration: tmp_menutouch_v2_speed,
            complete: function(){
                $('body').removeAttr('style');
                $('html').removeAttr('style');
            }
        });
        $('.tmp_menutouch_v2 ul').height('auto');
    });
});
